import { InjectionToken } from '@angular/core';

export const CORRESPONDANT_CLIENT = new InjectionToken<string>('ICorrespondantClient');

export const USER_INFO_CLIENT = new InjectionToken<string>('IuserInformationsClient');



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/resources/tokens/injectionTokens.ts